// OpenAI Ads pixel (oaiq) — chargé dans index.html (pixelId SqgFamrYFoVA46EEkC4U9P).
// Seule conversion mesurée côté client : `trial_started`, après confirmation serveur
// que le compte est créé et l'essai actif. Le même event_id (= uid Firebase) est envoyé
// côté serveur via l'API Conversions (proxy-server/services/openaiAds.js) : OpenAI
// dédoublonne pixel/API sur cet identifiant.

export const OPENAI_TRIAL_PLAN_ID = 'focuspips_7_day_trial';

const SENT_STORAGE_PREFIX = 'oaiq_trial_started:';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    oaiq?: (...args: any[]) => void;
  }
}

/**
 * Mesure `trial_started` une seule fois par compte (garde localStorage : un refresh
 * ou un second montage ne renvoie jamais l'événement). `eventId` = uid Firebase.
 */
export function trackOpenAiTrialStarted(eventId: string): void {
  if (typeof window === 'undefined' || !eventId) return;

  const storageKey = `${SENT_STORAGE_PREFIX}${eventId}`;
  try {
    if (window.localStorage.getItem(storageKey)) return;
  } catch {
    // localStorage indisponible (navigation privée) : on envoie quand même, OpenAI dédoublonne sur event_id.
  }

  if (typeof window.oaiq !== 'function') return;

  try {
    window.oaiq(
      'measure',
      'trial_started',
      { type: 'plan_enrollment', plan_id: OPENAI_TRIAL_PLAN_ID },
      { event_id: eventId },
    );
    window.localStorage.setItem(storageKey, new Date().toISOString());
  } catch {
    // Le tracking ne doit jamais casser l'inscription.
  }
}
